import { render, staticRenderFns } from "./Dispatching.vue?vue&type=template&id=dd106336&"
import script from "./Dispatching.vue?vue&type=script&lang=js&"
export * from "./Dispatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports